import { motion, AnimatePresence } from "framer-motion";

const SwipeConfirm = ({
  open,
  onClose,
  title,
  subTitle,
  desc,
  handleConfirm,
  type = "error",
}) => {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-[9999]"
            onClick={onClose}
          />

          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl z-[9999] max-h-[70vh] flex flex-col shadow-2xl text-base"
          >
            <div className="flex flex-col gap-3 px-3">
              <div className="flex w-full justify-center">
                <div className="bg-gray-200 w-[25%] h-1.5 rounded-full mt-2"></div>
              </div>
              <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
              <p className="text-slate-500">{desc}</p>
            </div>
            <div className="w-full rounded-t-3xl flex items-center gap-2 px-3 py-4">
              <button
                onClick={onClose}
                className="h-[40px] border border-error flex items-center justify-center gap-2 bg-white text-error w-full tracking-wide font-medium rounded-lg focus:outline-none focus:shadow-outline hover:bg-red-100 transform duration-200 hover:scale-100 disabled:bg-slate-400 disabled:cursor-disabled"
              >
                Batal
              </button>
              <button
                onClick={handleConfirm}
                className={`h-[40px] border border-${type === "success" ? "secondary" : "error"} flex items-center justify-center bg-${type === "success" ? "secondary" : "error"} text-white w-full tracking-wide font-medium rounded-lg focus:outline-none focus:shadow-outline hover:bg-${type === "success" ? "secondaryHover" : "red-700"} transform duration-200 hover:scale-100 disabled:bg-slate-400 disabled:cursor-disabled`}
              >
                {subTitle}
              </button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default SwipeConfirm;
